
define('ldsh!modules/accounts/users/list/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (collection.isRequest) {;
__p += '\n      <div class="spinner__container">\n        <i class="ri-loader-4-fill fa-spin"></i>\n      </div>\n\n';
 } else { ;
__p += '\n\n\n<div class="row">\n  <div class="col-md-9">\n    <p><strong class="i18n size20" data-i18n="ACCOUNTS.USERS.LBL_USER_LIST"></strong></p>\n    <p><span class="i18n size14" data-i18n="ACCOUNTS.USERS.LBL_USER_LIST_MSG"></span></p>\n  </div>\n  <div class="col-md-3">\n      <a id="createNewUser" data-groupId="' +
__e(groupId) +
'" class="pull-right btn boton-principal i18n" role="button" data-i18n="ACCOUNTS.USERS.LBL_NEW_USER"></a>\n  </div>\n</div>\n\n<div class="row">\n  <div class="col-md-12">\n\n        ';
 users.each(function(user) { ;
__p += '\n          ';
 var role;
            switch(user.get("role")) {
                  case "adm_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_ADM_MDIRECTOR";
                      break;
                  case "adm_mdirector_newfree":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_ADM_MDIRECTOR_FREEMIUM";
                      break;
                  case "analyst_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_ANALYST_MDIRECTOR";
                      break;
                  case "cpm_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_CPM_MDIRECTOR";
                      break;
                  case "cpu_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_CPU_MDIRECTOR";
                      break;
                  case "db_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_DB_MDIRECTOR";
                      break;
                  case "report_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_REPORT_MDIRECTOR";
                      break;
                  case "std_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_STD_MDIRECTOR";
                      break;
                  case "gcyc_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_GCYC_MDIRECTOR";
                      break;
                  case "uc_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_UC_MDIRECTOR";
                      break;
                  case "ndc_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_NDC_MDIRECTOR";
                      break;
                  case "cpm_report_mdirector":
                      role = "ACCOUNTS.USERS.DATATABLES.LBL_CPM_REPORT_MDIRECTOR";
                      break;
                  default:
                      role = user.get("role");
            }
          ;
__p += '\n\n        <div id="user-' +
__e(user.get('id')) +
'" class="panel panel-default">\n  <fieldset>\n    <div class="col-md-12">\n         <div class="nombre flex align-flex-start justify-space-between mb12">\n            <div class="flex align-center gap-2">\n              <span id="name-emp-' +
__e(user.get('id')) +
'" class="size20">' +
__e(user.get("name")) +
' ' +
__e(user.get("lastname")) +
'</span>\n              ';
 if(user.get("me")){;
__p += '\n                <span class="size16 i18n list-me ml5" data-i18n="ACCOUNTS.USERS.LBL_LIST_ME">TU</span>\n              ';
 } ;
__p += '\n              -\n              ' +
__e(user.get("email")) +
'\n              -\n              <span data-i18n="' +
__e(role) +
'" class="i18n"></span>\n            </div>\n            <a\n              href="/accounts/user/' +
__e(user.get('id')) +
'/group/' +
__e(groupId) +
'"\n              class="btn--rounded cambiarnombre i18n"\n              data-i18n="[title]ACCOUNTS.USERS.LBL_EDIT_USER"\n              data-emp_id="' +
__e(user.get('id')) +
'"\n            >\n              <i class="ri-edit-line"></i>\n            </a>\n\n           <!--\n            |\n            <a  id="popover-signup-' +
__e(user.get("id")) +
'" class="azul cambiarnombre i18n" data-i18n="ACCOUNTS.USERS.LBL_DELETE_USER_LIST" href="javascript: void(0)" data-emp_id="' +
__e(user.get("id")) +
'">Eliminar</a>\n            -->\n\n        </div>\n        <div class="servicios">\n\n\n            ';
 var count_services = 0; ;
__p += '\n                ';
  _.each(user.get("services"),function(service) { ;
__p += '\n                     ';
 if(service.activeServiceUser ==1){;
__p += '\n                       ';
 if(count_services !=0){;
__p += '\n                           /\n                        ';
 } ;
__p += '\n                       <strong class=" naranja i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICE_' +
__e(service.id) +
'"></strong>\n                     ';
 count_services++; ;
__p += '\n                     ';
 } ;
__p += '\n                 ';
 }); ;
__p += '\n         </div>\n    </div>\n  </fieldset>\n</div>\n\n\n\n        ';
 }); ;
__p += '\n     <!-- </tbody>\n    </table> -->\n  </div>\n</div>\n\n<div class="md__checkbox--wrapper gap16 mb48 mt24">\n  <input\n    id="show-no-actives"\n    type="checkbox"\n    class="md__checkbox--primary js-show-noactives"\n    ' +
__e((showNoActives ? "checked" : "")) +
'\n  />\n  <label\n    class="i18n gap16"\n    for="show-no-actives"\n    data-i18n="ACCOUNTS.COMPANIES.LBL_SHOW_NO_ACTIVE"\n  ></label>\n</div>\n\n';
 } ;
__p += '\n\n\n<div id=\'renderModalServices\'></div>\n';

}
return __p
};});

